import _remove from 'lodash/remove';
import _has from 'lodash/has';
import * as types from '../../contactUs/constants/ActionTypes';
import { docTypeOptions, getSearchFilter } from '../../lib/customFields';
import Page from '../../lib/page';

const FAQ = 'faq';
const PRODUCT = 'product';

const initialState = {
  formUpdated: false,
  queryParams: {},
  fields: getSearchFilter(),
  isSWS: false,
};

// If no query and 'product' option is valid for search filter, then return true
// Checker for 'PayPal Product' as default for SWS page
const isSWSOptions = (state, payload) => {
  const query = payload && payload.q;

  const fieldOptions = Page.getEligibleFilters();
  return !query && !state.formUpdated && fieldOptions.indexOf(PRODUCT) >= 0;
};

const preserveFormData = (state) => {
  const fields = getSearchFilter();
  const queryChannel = (state.queryParams && state.queryParams.channel) || '';

  let docType = FAQ;

  if (state.formUpdated && state.fields[0]) {
    docType = state.fields[0].value;
  } else if (queryChannel && _has(docTypeOptions, queryChannel)) {
    docType = queryChannel;
  } else if (!state.formUpdated && state.isSWS) {
    docType = PRODUCT;
  }

  fields[0].value = docType;

  return fields;
};

// Initial Product for loading SWS page
// Not passing search query for SWS search
const productFields = (state) => {
  const fields = state.fields;
  if (isSWSOptions(state)) {
    fields[0].value = PRODUCT;
  }

  return fields;
};

const removeButton = (stateFields) => {
  _remove(stateFields, (field) => (field.type === 'button'));
};

const initFields = (state) => {
  const fields = state.fields;
  const channel = state.queryParams && state.queryParams.channel;
  fields[0].value = channel;
  return fields;
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.RECEIVE_QUERY_PARAMS:
      return {
        ...state, formUpdated: false, queryParams: action.payload, fields: productFields(state), isSWS: isSWSOptions(state, action.payload),
      };
    case types.PRESERVE_FILTER_FIELD_DATA:
      return {
        ...state, formUpdated: true, fields: action.payload, isSWS: false,
      };
    case types.RECEIVE_ARTICLE_SEARCH_RESPONSE:
      return { ...state, formUpdated: false, fields: preserveFormData(state) };
    case types.RECEIVE_ARTICLE_SEARCH_ERROR:
      return { ...state, formUpdated: false, fields: preserveFormData(state) };
    case types.CLOSE_MOBILE_FILTER:
      removeButton(state.fields);
      return { ...state, fields: initFields(state) };
    case types.REQUEST_ARTICLE_SEARCH:
      removeButton(state.fields);
      return { ...state };
    default:
      return state;
  }
}
